import { CapoPlugin } from "/var/www/orthofresh2/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];